import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const HomeModule = lazy(loadModule);

export default HomeModule;
